// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rd-0";